import { defineComponent as _defineComponent } from 'vue'
import { getCurrentInstance, nextTick, onBeforeUnmount, onMounted } from 'vue';
import type { PropType } from 'vue';
import ProductCombinationsHeader from '@/components/global/popup/ProductCombinationsHeader.vue';
import CombinationsProductSlotRow from '@/components/global/popup/CombinationsProductSlotRow.vue';
import { EventBus } from '@/helpers/EventBusHelper';
import { EventBusEvents } from '@/enums/global/EventBusEvents';
import { UpdateProductFormEntry } from '@/interfaces/components/configurator/UpdateProductFormEntry';
import store from '@/store';

/* === Props & Emits === */

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductCombination',
  props: {
    productData: { type: Object as any, required: true },
    productsSelectedForCombination: { type: Array as PropType<number[]>, required: false },
    isAddingCombinations: { type: Boolean, required: false, default: false },
},
  emits: ['updateHiddenIndices'],
  setup(__props, { emit }) {

const props = __props;




const { proxy } = getCurrentInstance()!;
const componentProxy = proxy as any;

/* === Store Access & Configuration === */
const updateActiveProductFormValue = (entry: UpdateProductFormEntry) =>
    store.dispatch('configurator/updateActiveProductFormValue', entry);
const customFieldsSettingsForCombinations = [{ pId: 'p10301', value: true }];

/* === Combination Selection === */
function updateCombinationProductSelection(productFormId: number, selected: boolean) {
    if (selected) {
        props.productsSelectedForCombination!.push(productFormId);
    } else {
        const index = props.productsSelectedForCombination!.findIndex((id: number) => id === productFormId);
        props.productsSelectedForCombination!.splice(index, 1);
    }
}

function updateHiddenIndices() {
    updateWidthOfProductSlotWrappers();
    emit('updateHiddenIndices');
}

/* === Row Width Synchronization === */
function updateWidthOfProductSlotWrappers() {
    nextTick(async () => {
        let wrapperElements;

        wrapperElements = [
            ...(componentProxy.$refs.productSlotRow as any).map((productSlotRow: any) => productSlotRow.$refs.wrapper),
            (componentProxy.$refs.multipositionHeader as any).$refs.wrapper,
        ] as HTMLElement[];

        for await (const wrapperElement of wrapperElements) {
            wrapperElement.style.width = 'auto';
            await nextTick();
            wrapperElement.style.width = `${wrapperElement.clientWidth}px`;
        }
    });
}

function updateCustomFieldValues() {
    props.productData.itemRows.forEach((itemRow: any) => {
        customFieldsSettingsForCombinations.forEach((field: any) => {
            updateActiveProductFormValue({
                pId: field.pId,
                value: field.value,
                productFormId: itemRow.activeProductFormId,
            });
        });
    });
}

/* === Lifecycle === */
onMounted(() => {
    EventBus.$on(EventBusEvents.updateWidthOfProductSlotWrappers, updateWidthOfProductSlotWrappers);
    if (props.isAddingCombinations) {
        updateCustomFieldValues();
    }
});

onBeforeUnmount(() => {
    EventBus.$off(EventBusEvents.updateWidthOfProductSlotWrappers, updateWidthOfProductSlotWrappers);
});

return { __sfc: true,props, emit, proxy, componentProxy, updateActiveProductFormValue, customFieldsSettingsForCombinations, updateCombinationProductSelection, updateHiddenIndices, updateWidthOfProductSlotWrappers, updateCustomFieldValues, ProductCombinationsHeader, CombinationsProductSlotRow }
}

})